<div class="container">
  <div class="image-container">
    <img src="../../assets/images/empty-image.png" />
  </div>
  <div class="text-container">
    <div>{{ text }}</div>
  </div>
</div>
